import React from "react";

const EmailIcon = ({ size = 20, color = "#737373" }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.167 17.083H5.833c-2.5 0-4.166-1.25-4.166-4.166V7.083c0-2.917 1.666-4.167 4.166-4.167h8.334c2.5 0 4.166 1.25 4.166 4.167v5.834c0 2.916-1.666 4.166-4.166 4.166Z"
      stroke={color}
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m14.167 7.5-3.225 2.5c-.525.408-1.358.408-1.884 0L5.833 7.5"
      stroke={color}
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EmailIcon;
